var path = '/templates/projects.heatmap/views/directives/heatmap_table.html';
var html = "<div class=table-responsive><table class=\"table heatmap-table table-bordered\"><thead><tr><th class=heatmap-table-id>ID</th><th class=heatmap-table-status>URL</th></tr></thead><tbody><tr ng-repeat=\"page in pages\"><td style=text-align:center>{{ page.id }}</td><td><a ui-sref=\"admin.projects.heatmap.show({url: 1})\">{{page.name}}</a></td></tr></tbody></table></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../enterprise/src/zenclerk_modules/projects.heatmap/views/directives/heatmap_table.html
// module id = 1458
// module chunks = 0